import { formatCurrency } from '@/Utils/helpers';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';
import React from 'react';

const AvailableBalance = () => {
  const { data: user } = useCurrentUser();
  const balance = user?.stripe_balance;
  return (
    <div className='bg-bodyBg rounded-lg py-6 px-8 box-border mb-5'>
      <div className='flex justify-between items-center'>
        <div className='flex gap-8 items-center'>
          <img src='/icons/balance-icon.svg' alt='' />
          <p className='text-14px m-0 text-customBlack'>Available Balance</p>
        </div>
        <p className='text-20px font-normal text-customBlack m-0 font-sans'>
          {balance && formatCurrency(balance)}
        </p>
      </div>
      <span className='block border-b-1 border-draft border-solid w-full my-6' />
      <p className='text-14px text-customBlack'>
        Your available balance will be used first, and any remaining balance
        will be charged to your payment method on file.
      </p>
    </div>
  );
};
export default AvailableBalance;
